// extracted by mini-css-extract-plugin
export default {"container":"Ej-z","bubbleNav":"Fj-z","graphic":"Gj-z","contact":"Hj-z"};